import { Component } from '@angular/core';
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-tire-structure',
  standalone: true,
  imports: [FooterComponent, NavbarComponent],
  templateUrl: './tire-structure.component.html',
  styleUrl: './tire-structure.component.css'
})
export class TireStructureComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.tire_structure;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
